import styled from "styled-components";

export const BackButton = styled.button`
  background: none;
  border: none;
  color: #fff;
  font-family: Figtree;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: -0.075px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  margin-top: 16px;
  margin-left: -7px;
  opacity: 0.5;
  transition: all 0.2s ease-in-out;
  &:hover {
    opacity: 1;
  }
`;

export const Title = styled.h1`
  color: #fff;
  font-family: Figtree;
  font-size: 20px;
  font-weight: 500;
  line-height: 150%; /* 30px */
  letter-spacing: -0.1px;
`;

export const Tabs = styled.div`
  border-radius: 12px;
  background: #060e1a;
  display: flex;
  flex-direction: row;
  position: relative;
  height: 34px;

  &::before {
    content: "";
    position: absolute;
    top: 2px;
    left: ${({ $activeTab }) =>
      $activeTab === "scene" ? "2px" : "calc(50% + 1px)"};
    width: calc(50% - 2px);
    height: calc(100% - 4px);
    border-radius: 10px;
    border: 0.5px solid #2877d9;
    background: #142743;

    transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 1;
  }
`;
export const Tab = styled.button`
  width: 100%;
  background: none;
  border: none;
  outline: none;
  cursor: pointer;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  z-index: 2;
  letter-spacing: -0.21px;
  opacity: ${(p) => (p.$active ? 1 : 0.5)};
`;

export const Label = styled.span`
  font-family: Figtree;
  color: #fff;
  opacity: 0.3;
  font-size: 13px;
  font-weight: 400;
`;

export const Input = styled.input`
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  font-family: Figtree;
  letter-spacing: -0.21px;

  display: flex;
  height: 44px;
  padding: 12px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  outline: none;

  border-radius: 12px;
  border: 0.5px solid #325682;
  background: #142743;

  &:focus {
    border: 0.5px solid #2877d9;
  }
`;

export const Textarea = styled.textarea`
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  font-family: Figtree;
  letter-spacing: -0.21px;

  display: flex;
  min-height: calc(4 * 44px);
  padding: 12px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  outline: none;

  border-radius: 12px;
  border: 0.5px solid #325682;
  background: #142743;

  &:focus {
    border: 0.5px solid #2877d9;
  }
`;

export const Button = styled.button`
  display: flex;
  width: 100%;
  max-width: 322px;
  height: 42px;
  padding: 12px 44px;
  justify-content: center;
  align-items: center;
  gap: 10px;

  cursor: pointer;

  outline: none;
  border: none;

  border-radius: 100px;
  background: #fff;

  color: #081120;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  margin: 0 auto;
  margin-top: 34px;

  transition: all 0.2s ease-in-out;
  &:active {
    background: rgba(255, 255, 255, 0.75);
    scale: 0.985;
  }
  &:disabled {
    background: rgba(255, 255, 255, 0.45);
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  max-width: 600px;
  width: 100%;
  margin: 0 auto;
  flex: 1;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
`;
